import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils';
import { ConfirmarSenhaService } from '../../../services/confirmarSenha/confirmarSenhaService';
import { CONFIRMAR_SENHA, CONFIRMAR_SENHA_VALIDAR } from '../../../types/confirmarSenha/confirmarSenha';
import { ConfirmarSenhaRequest } from '../../../types/confirmarSenha/confirmarSenhaRequest';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { StateType } from 'domain/types/base/base';


const _ConfirmarSenhaService = new ConfirmarSenhaService();


export function ValidarTokenSenha(token: string, callBackError: ()=>void): AppThunk {
  return async (dispatch) => {
  const asyncResponse = await _ConfirmarSenhaService.ValidarTokenSenha({Token: token});
  

  if (ResponseValid(asyncResponse)) {
    dispatch({
      payload: true,
      type: CONFIRMAR_SENHA_VALIDAR
    });
  }else{
      dispatch({
        payload: false,
        type: CONFIRMAR_SENHA_VALIDAR
      });
      dispatch(DispatchLoading(CONFIRMAR_SENHA_VALIDAR, DispatchType.ERROR, "Token inválido", StateType.Local, {CallBackText: "Voltar", CloseText: null, CallBack: callBackError}))
  }

};
}

export function ConfirmarNovaSenha(payload: ConfirmarSenhaRequest): AppThunk {
    return async (dispatch) => {

    dispatch(DispatchLoading(CONFIRMAR_SENHA, DispatchType.LOADING, "Alterando", StateType.Master))

    const asyncResponse = await _ConfirmarSenhaService.ConfirmarSenha(payload, CONFIRMAR_SENHA);
    
    if (ResponseValid(asyncResponse)) {
      dispatch({
        payload: asyncResponse,
        type: CONFIRMAR_SENHA
      });
      dispatch(DispatchLoading(CONFIRMAR_SENHA, DispatchType.SUCCESS, "Senha alterada com Sucesso!", StateType.Master))
      return asyncResponse;
    }else{
        dispatch({
            payload: asyncResponse,
            type: CONFIRMAR_SENHA
        });
    }
  };
}


